import { message } from 'antd';
import axios from 'axios';

export const extractServerMessage = (data) => {
  const raw =
    data?.message ||
    data?.msg ||
    data?.error ||
    data?.detail ||
    data?.errors?.[0]?.message ||
    data?.errors?.message ||
    'Unknown server error';

  return typeof raw === 'object' ? JSON.stringify(raw) : raw;
};

export const handleAxiosError = (error) => {
  // 1. User canceled the request — completely silent
  if (axios.isCancel(error)) {
    return;
  }

  // 2. Report to Sentry if appropriate
  // if (shouldReportToSentry(error)) {
  //   Sentry.captureException(error);
  // }

  // Always log locally
  console.error(error);

  // 3. UI handling
  if (axios.isAxiosError(error)) {
    const { response, request, message: axiosMessage } = error;

    if (response) {
      const serverMessage = extractServerMessage(response.data);
      message.error(`Error ${response.status}: ${serverMessage}`);
      return;
    }

    if (request) {
      // Request was made but no response received
      message.error('Server not responding. Please check your network.');
      return;
    }

    // Something wrong while setting up the request config
    message.error(`Request setup error: ${axiosMessage}`);
    return;
  }

  // 4. Non-Axios runtime error (JS error inside .then(), etc.)
  message.error('An unexpected application error occurred.');
};
